import { render, staticRenderFns } from "./sidebar.vue?vue&type=template&id=19ed8cd1&scoped=true"
import script from "./sidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./sidebar.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./sidebar.vue?vue&type=style&index=0&id=19ed8cd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ed8cd1",
  null
  
)

export default component.exports